import React, { useState } from "react";
import {
  Modal,
  TextAreaInput,
  Button,
  IconButton,
  Tooltip,
} from "@toddle-edu/ds-web";

import classes from "./SystemPromptModal.scss";

import { useI18n } from "Hooks";
import { CopyOutlined } from "@toddle-edu/ds-icons";
import { copyToClipboard } from "Utils";
import { useDispatch } from "Hooks/useDispatch";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

const styles = {};

const SystemPromptModal = props => {
  const {
    systemPrompt,
    onModalClose,
    onSystemPromptUpdate,
    isPublicView,
  } = props;
  const [value, setValue] = useState(systemPrompt);
  const dispatch = useDispatch();
  const { t } = useI18n(["common"]);

  const onSaveButtonClick = () => {
    onSystemPromptUpdate(value);
    onModalClose();
  };

  const onCopyMessageClick = () => {
    copyToClipboard(value, () => {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:copied_capital",
          type: "success",
        })
      );
    });
  };
  return (
    <Modal width="1000px" height="max-content" onClose={onModalClose}>
      <Modal.Header title="System prompt" />
      <Modal.Body>
        <TextAreaInput
          value={value}
          size={"large"}
          placeholder={"You are a helpful assistant ..."}
          onChange={e => setValue(e.target.value)}
          style={styles.textAreaInput}
          minRows={20}
          maxRows={20}
          disabled={isPublicView}
        />
      </Modal.Body>
      <Modal.Footer hasSeparator={true}>
        <div className={classes.footerContainer}>
          <Tooltip tooltip={"Copy prompt"} placement={"top"}>
            <IconButton
              size={"large"}
              variant={"outlined-subtle"}
              icon={<CopyOutlined />}
              onClick={onCopyMessageClick}
            />
          </Tooltip>
          <Button size="large" variant="outlined-subtle" onClick={onModalClose}>
            {t("common:cancel")}
          </Button>
          {!isPublicView ? (
            <Button
              size="large"
              variant="progressive"
              onClick={onSaveButtonClick}
            >
              {t("common:save")}
            </Button>
          ) : null}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default SystemPromptModal;
